import { render } from "./ResetForm.vue?vue&type=template&id=74be9360&scoped=true"
import script from "./ResetForm.vue?vue&type=script&lang=js"
export * from "./ResetForm.vue?vue&type=script&lang=js"

import "./ResetForm.vue?vue&type=style&index=0&id=74be9360&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2236819739/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74be9360"]])

export default __exports__